import { useInfiniteQuery, useQuery, type QueryClient } from '@tanstack/react-query';
import { feedApi } from '../../services/feedApi';
import { getFeedItemComments } from '../../firebase';

const PAGE_SIZE = 10;

export const useFeed = () => {
  return useInfiniteQuery({
    queryKey: ['feed'],
    queryFn: async ({ pageParam = undefined }: { pageParam?: string }) => {
      const items = await feedApi.getFeedTimeline(PAGE_SIZE, pageParam);
      return {
        items,
        nextCursor: items.length === PAGE_SIZE ? items[items.length - 1].latestTimestamp : undefined,
      };
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    maxPages: 10,
    staleTime: 60 * 1000,     // 1 minute
    gcTime: 15 * 60 * 1000,   // 15 minutes
  });
};

export const prefetchFeed = (queryClient: QueryClient) => {
  return queryClient.prefetchInfiniteQuery({
    queryKey: ['feed'],
    queryFn: async ({ pageParam = undefined }: { pageParam?: string }) => {
      const items = await feedApi.getFeedTimeline(PAGE_SIZE, pageParam);
      return {
        items,
        nextCursor: items.length === PAGE_SIZE ? items[items.length - 1].latestTimestamp : undefined,
      };
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage: any) => lastPage?.nextCursor,
    staleTime: 60 * 1000,
  });
};

export const useFeedItemComments = (itemId: string | undefined) => {
  return useQuery({
    queryKey: ['feed', itemId, 'comments'],
    queryFn: () => {
      if (!itemId) throw new Error("No item ID provided");
      return getFeedItemComments(itemId);
    },
    enabled: !!itemId,
  });
};
